import { NgModule } from '@angular/core';

// Components
import { ManageQueuesComponent } from './manage-queues.component';
import { ManageQueuesRoutingModule } from './manage-queues.routing.module';
import { QueueSearchbarComponent } from './components/queue-searchbar/queue-searchbar.component';
import { QueueEditorDialogComponent } from './components/dialog/queue-editor/queue-editor.dialog.component';
import { CustomQueueNameCellComponent } from './components/custom-cell/name/custom-name-cell.component';
import { CustomQueueActionCellComponent } from './components/custom-cell/action/custom-queues-action-cell.component';
import { QueueRuleBuilderComponent } from './components/json-filter-builder/json-filter-builder.component';
import { ResolveDialogComponent } from './components/dialog/resolve-dialog/resolve-dialog.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// Modules
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
// Services
import { QueuesService } from './service/queues.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';


@NgModule({
    imports: [
        ButtonModule,
        InputTextModule,
        FormsModule,
        ReactiveFormsModule,
        ManageQueuesRoutingModule,
        CvComponentLibraryModule,
        CommonModule,
        AgGridModule.withComponents([]),
        ToastModule,
        ConfirmDialogModule,
        InputTextareaModule,
        MultiSelectModule,
        DropdownModule,
        CalendarModule
    ],
    exports: [],
    declarations: [
        ManageQueuesComponent,
        QueueSearchbarComponent,
        QueueEditorDialogComponent,
        QueueRuleBuilderComponent,
        ResolveDialogComponent,
    ],
    providers: [QueuesService, DialogService, MessageService, ConfirmationService],
    entryComponents: [CustomQueueNameCellComponent, CustomQueueActionCellComponent],
})
export class ManageQueuesModule {}
